import type { DetectedPlugin } from '../types';

/**
 * Reaper .rpp plain-text parser.
 *
 * Reaper stores plugin info in lines like:
 *   <VST "Plugin Name (Vendor)" "filename.dll" 0 "" uniqueid ""
 *   <VST3 "Plugin Name" "filename.vst3" ...
 *   <CLAP "Plugin Name" "filename.clap" ...
 */

const VST2_RE = /^\s*<VST\s+"([^"]+)"\s+"([^"]*)"/gim;
const VST3_RE = /^\s*<VST3\s+"([^"]+)"/gim;
const CLAP_RE = /^\s*<CLAP\s+"([^"]+)"\s+"([^"]*)"/gim;

function parseVendor(combined: string): { name: string; vendor?: string } {
  // Format is usually "Plugin Name (Vendor Name)"
  const match = combined.match(/^(.*?)\s*\(([^)]+)\)\s*$/);
  if (match) {
    return { name: match[1].trim(), vendor: match[2].trim() };
  }
  return { name: combined.trim() };
}

export function parseReaper(bytes: Uint8Array): DetectedPlugin[] {
  const text = new TextDecoder('utf-8').decode(bytes);
  const plugins: DetectedPlugin[] = [];

  let m: RegExpExecArray | null;

  VST2_RE.lastIndex = 0;
  while ((m = VST2_RE.exec(text)) !== null) {
    const { name, vendor } = parseVendor(m[1]);
    if (name) {
      plugins.push({
        name,
        vendor,
        pluginType: 'VST2',
        confidence: 0.92,
        detectionMethod: 'structured',
      });
    }
  }

  VST3_RE.lastIndex = 0;
  while ((m = VST3_RE.exec(text)) !== null) {
    const { name, vendor } = parseVendor(m[1]);
    if (name) {
      plugins.push({
        name,
        vendor,
        pluginType: 'VST3',
        confidence: 0.92,
        detectionMethod: 'structured',
      });
    }
  }

  CLAP_RE.lastIndex = 0;
  while ((m = CLAP_RE.exec(text)) !== null) {
    const { name, vendor } = parseVendor(m[1]);
    if (name) {
      plugins.push({
        name,
        vendor,
        pluginType: 'CLAP',
        confidence: 0.92,
        detectionMethod: 'structured',
      });
    }
  }

  return plugins;
}
